import React, { useState, useEffect } from 'react';
import AuthPanel from './AuthPanel';

const AuthModal = ({ isOpen, onClose, initialMode = 'login' }) => {
  const [mode, setMode] = useState(initialMode);

  // El modal se monta una sola vez, así que sin esto el modo se quedaría
  // congelado en el primero que se pidió (abrir "Registrarse" tras haber
  // abierto "Iniciar sesión" mostraba el login).
  useEffect(() => {
    if (isOpen) setMode(initialMode);
  }, [isOpen, initialMode]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleSuccess = () => {
    onClose();
    // No recargamos la página para mantener el estado de la aplicación
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleOverlayClick}
    >
      <div className="bg-df-surface border border-df-border rounded-lg shadow-xl w-full max-w-md max-h-screen overflow-y-auto">
        <div className="flex justify-between items-center p-4 border-b border-df-border">
          <h2 className="text-2xl font-bold text-df-text">
            {mode === 'login' ? 'Iniciar Sesión' : 'Registrarse'}
          </h2>
          <button
            onClick={onClose}
            className="text-df-muted hover:opacity-80"
            aria-label="Cerrar"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <AuthPanel
          mode={mode}
          onModeChange={setMode}
          onSuccess={handleSuccess}
          onDismiss={onClose}
        />
      </div>
    </div>
  );
};

export default AuthModal;
